var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',[_c('p',{staticClass:"h3"},[_vm._t("title")],2)]),_c('div',{staticClass:"ml-auto d-flex"},[_vm._t("cancel"),_vm._t("save")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }